module.exports = __webpack_public_path__ + "3d-printers-parts.png?8269ebdf2724a7e13e7274477183c010";